import { Environment } from '../models/environment';
import { trackjsErrorHandler } from '../partials/trackjs-error.handler';
import { serviceApiBaseUrls } from './service-api-base-urls/urls';

export const environment = new Environment({
  name: 'qa',
  soleraSiteUrl: 'https://navigation2-qa.omnitracs.com',
  onboardingSiteUrl: 'https://onboarding-qa.trimblemaps.com',
  routeReporterUrl: 'https://routereporter-qa.trimblemaps.com',
  contentToolsUrl: 'https://contenttools-qa.alk.com',
  pcMilerWebServicesApiKey: '48667533B12E8942B038B8533A35F4A5',

  onboardingSite: {
    productName: 'OnBoarding',
    tid: {
      appName: 'Onboarding_Site--dev-qa',
      clientId: 'fc7f593b-3163-4c94-92c6-6cd295dd19b0',
    },
  },

  accountManagerSite: {
    productName: 'Account Management',
    brazeWorkspaceApiKey: 'd8baab59-c614-415b-8171-ff4fedc914f5',
    tid: {
      appName: 'Account_Manager--dev-qa',
      clientId: '53d88564-d7c8-4384-bdcc-7d4e7fb03d39',
    },
    trimbleMapsSdkApiKey: '68B06901AF7DA34884CE5FB7A202A743',
    eldSyncStatusPollingRateMs: 30000,
    freshchat: {
      widgetUrl: 'https://trimblemaps.freshchat.com/js/widget.js',
      settings: {
        token: '797ed190-4ef3-4faa-81f8-367d7ba5e6dc',
        host: 'https://trimblemaps.freshchat.com',
        widgetUuid: 'ffd8e224-c958-4eeb-9760-a5bc1c3710bb',
        config: {
          headerProperty: {
            hideChatButton: true,
          },
          eagerLoad: true,
        },
      },
    },
  },

  serviceApiBaseUrls: serviceApiBaseUrls,
  flagSmithConfig: {
    environmentID: '33VsnLwADj9FCLHjVoHMvv',
  },
  brazeUrl: 'https://rest.iad-01.braze.com',
  brazeRestApiKey: 'acd7699d-1be4-4bdf-b8c0-55be745812e4',
  brazeWorkspaceApiKey: 'd8baab59-c614-415b-8171-ff4fedc914f5',
  brazeUuidHash: '896d6b39-367c-430c-99fb-2af9972ee2d1',
  trackjsConfig: {
    application: 'ams-qa',
    console: {
      enabled: true,
      display: true,
      error: false,
    },
    network: {
      enabled: true,
      error: false,
    },
    onError: trackjsErrorHandler,
    token: 'd70d579b2a5f48f09a3e05be4362d9ac',
    window: {
      enabled: false,
      promise: false,
    },
  },
});
